import { forwardRef, useState, useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

/**
 * Imagen de código de barras CODE128 lista para imprimirse en el PDF.
 * Renderiza a un canvas en memoria y exporta como dataURL para evitar
 * problemas de timing con html2pdf.
 */
export const BarcodeImage = ({ value, width = 1.5, height = 40 }) => {
  const canvasRef = useRef(null);
  const [dataUrl, setDataUrl] = useState(null);

  useEffect(() => {
    if (value) {
      const canvas = document.createElement('canvas');
      try {
        JsBarcode(canvas, value, {
          format: 'CODE128',
          width,
          height,
          displayValue: true,
          fontSize: 10,
          textMargin: 2,
          margin: 5,
          background: '#ffffff',
          lineColor: '#000000',
        });
        setDataUrl(canvas.toDataURL('image/png'));
      } catch (error) {
        console.error('Error generating barcode:', error);
      }
    }
  }, [value, width, height]);

  if (!dataUrl) return null;
  return (
    <img
      ref={canvasRef}
      src={dataUrl}
      alt={`Código: ${value}`}
      style={{ maxWidth: '100%', height: 'auto' }}
    />
  );
};

/**
 * Celda de foto con manejo robusto de carga/error.
 * El placeholder ocupa todo el espacio cuando la imagen no ha cargado
 * (o ha fallado), evitando huecos negros en el PDF impreso.
 */
export function PdfPhotoCell({ url, alt }) {
  const [status, setStatus] = useState('loading'); // loading | ok | error
  return (
    <div style={{
      position: 'relative',
      border: '1px solid #d4d4d8',
      borderRadius: '2px',
      overflow: 'hidden',
      height: '82mm',
      backgroundColor: '#fafafa',
      WebkitPrintColorAdjust: 'exact',
      printColorAdjust: 'exact',
    }}>
      <img
        src={url}
        alt={alt}
        loading="eager"
        decoding="sync"
        onLoad={() => setStatus('ok')}
        onError={() => setStatus('error')}
        style={{
          position: 'absolute', inset: 0,
          width: '100%', height: '100%', objectFit: 'cover',
          display: status === 'ok' ? 'block' : 'none',
        }}
      />
      {status !== 'ok' && (
        <div style={{
          position: 'absolute', inset: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexDirection: 'column',
          color: '#9ca3af',
          backgroundColor: '#fafafa',
          fontSize: '7px', textAlign: 'center', padding: '2mm',
        }}>
          <span>{status === 'error' ? 'Imagen no disponible' : 'Cargando…'}</span>
        </div>
      )}
    </div>
  );
}

// Re-export para mantener API consistente
export { forwardRef };
